import React from 'react'
import { connect } from 'react-redux'
import ReactTable from 'react-table'
import { Icon } from 'semantic-ui-react'
import { reduxForm, getFormValues } from 'redux-form'
import { ShortListContainer } from './styled'
import { MainBodyContent, CustomButton, SearchList, TablePagination } from 'components'
import { ProcurementContainer, ProcurementBody } from 'routes/ProcurementSystem/styled'
import { shortListCreatePath, shortListEditPath, shortListDetailPath } from 'routes'
import { getShortLists } from 'ducks/shortList'
import { slColumns } from './attributeData'
import { getCompanies } from 'ducks/options'

const ShortList = (props) => {
  const { listShortLists, valueForm, companies } = props
  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(() => {
    window.scrollTo(0, 0)
    props.getShortLists({ page: 1, size: pageSize })

    if (!companies.data.length && !companies.loading) {
      props.getCompanies()
    }
  }, [])

  return (
    <MainBodyContent headerTitle='Short List'
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(shortListCreatePath)}
            icon='plus'
            btnColor='gray'
            title='Create' />
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList 
            placeholder='Doc No., Title, Requester' 
            fetchAPI={props.getShortLists} 
            formSearchName='formSearchShortList' 
            filterDate 
            filterStatus 
            hideProject={true}
            pageSize={userPageSize}
          />
          <ShortListContainer>
            <ReactTable
              data={Object.keys(listShortLists).length > 0 ? listShortLists.data : []}
              columns={slColumns(companies.data)}
              defaultPageSize={userPageSize}
              noDataText='No data short list request.'
              previousText={<Icon name='arrow alternate circle left' />}
              nextText={<Icon name='arrow alternate circle right' />}
              className='-striped -highlight'

              PaginationComponent={TablePagination}
              pages={Object.keys(listShortLists).length > 0 ? listShortLists.totalPage : 0}
              currentPage={Object.keys(listShortLists).length > 0 ? listShortLists.page : 0}
              onPageChange={(pageIndex) => {
                props.getShortLists({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.getShortLists({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      if ([0, 5,10,11].indexOf(Number(rowInfo.original.status)) >= 0) {
                        props.history.push(shortListEditPath(rowInfo.original.id))
                      } else {
                        props.history.push(shortListDetailPath(rowInfo.original.id))
                      }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </ShortListContainer>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formSearchShortList')(state),
    listShortLists: state.shortList.listShortLists.data,
    companies: state.options.companies,
  })
}

const mapDispatchToProps = {
  getShortLists,
  getCompanies
}

const ShortListForm = reduxForm({
  form: 'formSearchShortList',
  enableReinitialize: true,
})(ShortList)

export default connect(mapStateToProps, mapDispatchToProps)(ShortListForm)